import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { DocumentLanguageService } from './document-language.service';

/**
 * Keeps `<html lang>` and `<html dir>` in step with the active language from startup on. Included
 * in `TranslocoRootModule`, so apps that import that module need nothing more.
 */
export function provideDocumentLanguage(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(DocumentLanguageService).start()),
  ]);
}
